import { ArrowLeft } from "lucide-react";
import { Button } from "react-bootstrap";

/** Above the whole app while a banner is previewed: it is not live, and only this admin sees it (MPN-2266). */
export default function BannerPreviewBar({ onBack }: { onBack: () => void }) {
    return (
        <div className="dashboard-banner__preview-bar" role="region" aria-label="Banner preview">
            <span className="dashboard-banner__preview-label">ADMIN PREVIEW</span>
            <span className="dashboard-banner__sep" aria-hidden="true">|</span>
            <span className="dashboard-banner__preview-copy">This banner is not live. Only you can see it here.</span>
            <Button variant="neutral-on-dark" size="sm" className="dashboard-banner__spacer d-inline-flex align-items-center gap-1" onClick={onBack}>
                <ArrowLeft size={14} aria-hidden="true" />
                Back to Editor
            </Button>
        </div>
    );
}
